import React from "react";
import { Link, useLocation } from "react-router-dom";

const breadcrumbNameMap = {
  dashboard: "Dashboard",
  settings: "Settings",
  profile: "Profile",
  "personal-info": "Personal Info",
  edit: "Edit",
  expenses: "Expenses",
  "list-expenses": "List Expenses",
  calendar: "Calendar",
  appointments: "Appointments",
    "patient-app-details": "Patient App Details",
  users: "Users",
  "list-patients": "List Patients",
  PsychologicalForm: "Psychological Form",
  "list-medicine": "List-Medicine", 
  
  
};

const formatName = (slug) =>
  slug
    .replace(/([A-Z])/g, " $1")
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        fontSize: "13px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        margin: "8px 0 8px 12px",
        
      }}
    >
      <Link to={"/"} style={{ color: "#1c1a1aff", textDecoration: "none" }}>
        Home
      </Link>

      {pathnames.map((value, index) => {
        const to = "/" + pathnames.slice(0, index + 1).join("/");
        const key = pathnames.slice(0, index + 1).join("-"); 
        if (/^[0-9a-fA-F]{24}$/.test(value)) return null;

        const name = breadcrumbNameMap[key] || formatName(value);
        const isLast = index === pathnames.length - 1;

        return (
          <span key={to} style={{ display: "flex", alignItems: "center" }}>
            <span style={{ margin: "0 6px", color: "#ccc" ,  }}>{">"}</span>
            {isLast ? (
              <span style={{ color: "#2f2b2bff" , cursor:"pointer" }}>{name}</span>
            ) : (
              <Link
                to={"/"}
                style={{
                  color: "#2f2b2bff",
                  textDecoration: "none",
                  
                }}
              >
                {name}
              </Link>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
